import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import MapLayers from './MapLayers';
import MapInfoBar from './MapInfoBar';
import UserInfoDrawer from './UserInfoDrawer';
import NavOptions from './NavOptions';
import NavOptionPages from './NavOptions/Pages';
import {handleErrors, checkUserLoggedIn, logOutUser, shouldInitializeDefaultState, showAppUpdateToaster, shouldInitializeUserData, showToasterError} from './../utils';
import {initializeDefaultStates, initializeUserStates} from './../actions';
import {updateParkingSpots, selectSpot, zoomByCoordinates} from '../actions/parkingSpots';
import {pusherClient, statusChannelName} from '../utils/pusher';
import {setPusherSocketId} from '../actions/pusher';
import {handleStatusChange, afterErrorMessageReceived} from '../actions/updateChannelSubscribe';
import {GLOBAL_STATUS_UPDATE_CHANNEL_PREFIX, GLOBAL_STATUS_UPDATE_CHANNEL_MESSAGE, API_RESPONSE_MESSAGE, GLOBAL_APP_RELOAD_MESSAGE} from '../constants/pusher';
import {UPDATE_CHANNEL_DEBOUNCE_INTERVAL, UIDEVENT} from '../constants';


class ParkingHome extends Component {

  constructor(props) {
    super(props);
    this.pusher = pusherClient();
  }

  componentWillMount() {
    if(Object.keys(this.props.parkingSpotFeaturesList).length) {
      this.checkUrlSpotPresentOrNot(this.props);
    }
    if(shouldInitializeDefaultState()) {
      this.props.initializeDefaultStates();
    }

    if (this.props.isUserLoggedIn && shouldInitializeUserData()) {
      this.props.initializeUserStates();
    }

    this.pusher.connection.bind('connected', () => {
      const pusherSocketId = this.pusher.connection.socket_id;
      this.props.setPusherSocketId(pusherSocketId);

      const updatesChannel = this.pusher.subscribe(GLOBAL_STATUS_UPDATE_CHANNEL_PREFIX + UIDEVENT.toLowerCase());
      let CACHE_DATA = {};
      let isQueued = false;
      updatesChannel.bind(GLOBAL_STATUS_UPDATE_CHANNEL_MESSAGE, (data) => {
        Object.assign(CACHE_DATA, data);
        if(!isQueued) {
          isQueued = true;
          setTimeout(() => {
            if (Object.keys(CACHE_DATA).length) {
              this.props.updateParkingSpots(CACHE_DATA);
            }
            CACHE_DATA = {};
            isQueued = false;
          }, UPDATE_CHANNEL_DEBOUNCE_INTERVAL);
        }
      });

      updatesChannel.bind(GLOBAL_APP_RELOAD_MESSAGE, (data) => {
        showAppUpdateToaster();
      });

      const channel = statusChannelName(pusherSocketId);

      const statusUpdateChannel = this.pusher.subscribe(channel);
      statusUpdateChannel.bind(API_RESPONSE_MESSAGE, (body) => {

        if(body.requestID === this.props.requestId) {
          const {data} = body;
          if (data.success ){
            this.props.handleStatusChange(data, body.requestID, this.props.event);
          } else if(data.hasOwnProperty('errors')) {
            handleErrors(data.errors);
            this.props.afterErrorMessageReceived();
          }
        }

      });
    });
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.parkingSpotFeaturesList !== this.props.parkingSpotFeaturesList){
      if(Object.keys(nextProps.parkingSpotFeaturesList).length) {
        this.checkUrlSpotPresentOrNot(nextProps);
      }
    }
  }

  componentWillUnmount() {
    this.pusher.unsubscribe(GLOBAL_STATUS_UPDATE_CHANNEL_MESSAGE);
  }

  checkUrlSpotPresentOrNot (props)  {
    const { selectedSpot, params, parkingSpotFeaturesList } = props;
    let { spot_id:paramSpotId } = params;
    if(!paramSpotId && selectedSpot) {
      paramSpotId = selectedSpot;
    }
    if (paramSpotId) {
      if(parkingSpotFeaturesList.hasOwnProperty(paramSpotId)) {
        const { centerCoordinates } = parkingSpotFeaturesList[paramSpotId];
        props.selectSpot(paramSpotId);
        props.zoomByCoordinates(centerCoordinates);
      }else {
        showToasterError(`Spot ${paramSpotId} could not be found on the map. Try searching at the top.`);
        browserHistory.push(`/parking`);
      }
    }
  }

  render() {
    const { isReadOnly } = this.props;
    return (
      <div style={{position: 'relative', height: '100%'}}>
        <MapInfoBar isReadOnly={isReadOnly} />
        <NavOptions />
        <UserInfoDrawer isReadOnly={isReadOnly} />
        <NavOptionPages />
        <MapLayers />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { dtmOpen, dtmClose } = state.mapAccommodationInfo;
  const { isBookingOpen, parkingSpotFeaturesList } = state.session;
  const { selectedSpot } = state.parkingSpots;

  return {
    selectedSpot,
    parkingSpotFeaturesList,
    isReadOnly: !isBookingOpen,
    pusherSocketId: state.pusher.socketId,
    requestId: state.checkout.requestId,
    event: state.checkout.event,
    isUserLoggedIn: checkUserLoggedIn(state.user),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    initializeDefaultStates, initializeUserStates,
    setPusherSocketId, handleStatusChange, logOutUser,
    updateParkingSpots, afterErrorMessageReceived, selectSpot, zoomByCoordinates
  }, dispatch);
};


export default connect(mapStateToProps, mapDispatchToProps)(ParkingHome);



// WEBPACK FOOTER //
// ./src/containers/ParkingHome.js